import * as React from 'react';
import PropTypes from 'prop-types';
import {
    Redirect,
    Route, Switch,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { IdleTimer } from '../../youwell-common/components';
import { logoutReasons } from '../../youwell-common/constants';
import Auth, { authTypes } from '../../youwell-common/Auth';

import * as AuthStore from '../../app/store/AuthStore';

import urls from '../../app/urls';
import { InternalLinkLoader, Layout } from '../../common/components';
import LoadProgram from './components/LoadProgram';
import Program from './Program';
import Module from './Module';
import Task from './Task';
import Home from './Home';
import { getPublicProgramContentLink } from '../../common/taskUtils';
import Footer from './components/Footer';

const USER_IDLE_TIMEOUT_IN_MINUTES = 30;

class Index extends React.Component {
    logoutOnIdle = () => {
        if (Auth.isUserAuthenticated(authTypes.public)) {
            this.props.logout(logoutReasons.idleTimeout, urls.public.home);
        }
    }

    render() {
        const { program } = this.props;

        return (
            <>
                <IdleTimer
                    timeoutInMinutes={USER_IDLE_TIMEOUT_IN_MINUTES}
                    onIdle={this.logoutOnIdle}
                />

                <InternalLinkLoader linkUrlFunction={link => getPublicProgramContentLink(link, program)} />

                <Route path={`${urls.public.program}/:programId`} component={LoadProgram} />

                <Layout
                    hideHeaderLinks
                    hideMenu
                    hideAppTitle
                    headerPageTitle={this.props.program?.name}
                >
                    <Switch>
                        <Route path={`${urls.public.program}/:programId/:moduleIndex/:taskIndex`} component={Task} />
                        <Route path={`${urls.public.program}/:programId/:moduleIndex`} component={Module} />
                        <Route path={`${urls.public.program}/:programId`} component={Program} />
                        <Route exact path={`${urls.public.home}/:programId`} render={props => <Redirect to={`${urls.public.program}/${props.match.params.programId}`} />} />
                        <Route path={urls.public.home} component={Home} />
                    </Switch>

                    <Footer />
                </Layout>
            </>
        );
    }
}

Index.propTypes = {
    logout: PropTypes.func.isRequired,
    program: PropTypes.object,
};

Index.defaultProps = {
    program: null,
};

const mapStateToProps = state => ({
    clientConfig: state.auth.clientConfig,
    program: state.publicStore.details && state.publicStore.currentProgramId && state.publicStore.details[state.publicStore.currentProgramId],
});

const mapDispatchToProps = dispatch => ({
    logout: bindActionCreators(AuthStore.actionCreators, dispatch).logout,
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
